import React from "react";
import { Select, SelectProps } from "antd";
import { useGetUsimSkusQuery } from "../../../api/usim/uploads/products/productSkuApi";

interface UsimSkuDropdownProps extends SelectProps {
  typeName?: string;
}

export const UsimSkuDropdown: React.FC<UsimSkuDropdownProps> = ({ typeName, ...props }) => {
  // Always fetch all SKUs to enable local filtering
  // This is more performant for ~10k items than repeated API calls
  const { data: allSkus, isFetching } = useGetUsimSkusQuery();

  const options = React.useMemo(() => {
    if (!allSkus) return [];
    
    let filteredData = allSkus;
    
    // Filter by typeName if provided
    if (typeName) {
      filteredData = allSkus.filter(item => item.typeName === typeName);
    }

    return filteredData
      .filter((item) => item.status !== 'INACTIVE')
      .map((item) => ({
        label: item.name,
        value: item.name,
        type: item.typeName,
      }));
  }, [allSkus, typeName]);

  return (
    <Select
      placeholder="Select product SKU"
      showSearch
      filterOption={(input, option) =>
        String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      loading={isFetching}
      options={options}
      {...props}
    />
  );
};
